import(/* webpackMode: "eager" */ "/home/runner/work/holy_trinity/holy_trinity/src/app/appointments/page.tsx");
